class Osmo0908InTheBox extends HTMLElement {
  connectedCallback() {
    if (this.initialized || this.dataset.layoutMode !== 'carousel') return;

    this.viewport = this.querySelector('[data-op0908-box-viewport]');
    this.track = this.querySelector('[data-op0908-box-track]');
    this.previousButton = this.querySelector('[data-op0908-box-previous]');
    this.nextButton = this.querySelector('[data-op0908-box-next]');
    this.controls = [this.previousButton, this.nextButton].filter(Boolean);

    if (!this.viewport || !this.track || this.controls.length !== 2) return;

    this.initialized = true;
    this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.handleClick = this.handleClick.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.handleResize = this.handleResize.bind(this);

    this.addEventListener('click', this.handleClick);
    this.viewport.addEventListener('scroll', this.handleScroll, { passive: true });
    this.viewport.addEventListener('keydown', this.handleKeydown);
    this.resizeObserver = new ResizeObserver(this.handleResize);
    this.resizeObserver.observe(this.viewport);
    this.resizeObserver.observe(this.track);
    requestAnimationFrame(() => this.updateControls());
  }

  disconnectedCallback() {
    if (!this.initialized) return;

    this.removeEventListener('click', this.handleClick);
    this.viewport?.removeEventListener('scroll', this.handleScroll);
    this.viewport?.removeEventListener('keydown', this.handleKeydown);
    this.resizeObserver?.disconnect();
    cancelAnimationFrame(this.animationFrame);
    this.initialized = false;
  }

  handleClick(event) {
    const button = event.target.closest('[data-op0908-box-previous], [data-op0908-box-next]');
    if (!button || !this.contains(button) || button.disabled) return;

    this.scrollByCard(button.hasAttribute('data-op0908-box-next') ? 1 : -1);
  }

  handleScroll() {
    cancelAnimationFrame(this.animationFrame);
    this.animationFrame = requestAnimationFrame(() => this.updateControls());
  }

  handleKeydown(event) {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

    event.preventDefault();
    this.scrollByCard(event.key === 'ArrowRight' ? 1 : -1);
  }

  handleResize() {
    cancelAnimationFrame(this.animationFrame);
    this.animationFrame = requestAnimationFrame(() => this.updateControls());
  }

  scrollByCard(direction) {
    const card = this.track.querySelector('.osmocam-0908-in-the-box__item');
    if (!card) return;

    const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
    const distance = card.getBoundingClientRect().width + gap;
    this.viewport.scrollBy({
      left: direction * distance,
      behavior: this.motionQuery.matches ? 'auto' : 'smooth',
    });
  }

  updateControls() {
    const maxScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
    const canScroll = maxScroll > 1;

    this.controls.forEach((control) => {
      control.hidden = !canScroll;
    });

    if (!canScroll) {
      this.previousButton.disabled = true;
      this.nextButton.disabled = true;
      delete this.dataset.carouselReady;
      return;
    }

    this.dataset.carouselReady = 'true';
    this.previousButton.disabled = this.viewport.scrollLeft <= 1;
    this.nextButton.disabled = this.viewport.scrollLeft >= maxScroll - 1;
  }
}

if (!customElements.get('osmocam-0908-in-the-box')) {
  customElements.define('osmocam-0908-in-the-box', Osmo0908InTheBox);
}
